import React, { useRef } from 'react'
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs

// Components
import Lottie from '@/components/common/Lottie'

// Styles
import styles from './style.module.scss'

// Lotties
import connectingDataEcosmetics from '@/assets/lotties/connecting-new.json'

const cx = classnames.bind(styles)

const Connecting = () => {
  const connectingRef = useRef<any>(null)
  const { t } = useTranslation()

  return (
    <>
      <div className={cx('connecting-animation-area')}>
        <div className={cx('connecting__animation')}>
          <div ref={connectingRef} className={cx('connecting__animation-content')}>
            <Lottie lottieRef={connectingRef} animationData={connectingDataEcosmetics} />
          </div>
          <div className={cx('connecting__animation-background')}>
            <div className={cx('connecting__animation-text')}>{t('LiveRoom_Connecting_Text')}</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Connecting
